/*
 * @Author: your name
 * @Date: 2021-01-19 12:14:20
 * @LastEditTime: 2021-09-26 18:21:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lavrock-official-platform\src\store\modules\template\template.mutations.js
 */
import _ from 'lodash'

const mutations = {
	setState(state, data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				if(key === 'pageId') {
					window.sessionStorage.setItem(`${state.projId}-currentId`, data[key])
				}
				state[key] = data[key]
			}
		}
	},
	setConfigFtp(state, data) {
		state.configFtp = data
	},
	updatedPageUrl(state, { pageId, pagePath }) {
		let mapNavList = state.pageNavList.map(item => {
			if(item.navPageId === pageId) {
				item.navPagePath = pagePath
			}
			return item
		})
		state.pageNavList = mapNavList
	},
	SET_PROJ_INFO(state,data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				state.projInfo[key] = data[key]
			}
		}
	},
	// 重置插件
	resetPlugin(state) {
		state.pluginGroup = {}
	},
	// 设置编辑窗口window对象
	setTemplateWindow(state, windowDoc) {
		state.templateWindow = windowDoc
	},
	// 设置toolbarState状态
	setToolbarState(state, params) {
		for (let keys in params) {
			state.toolbarState[keys] = params[keys]
		}
	},
	setToolbarStateInit(state, time) {
		if (_.isNumber(time)) { // ms
			setTimeout(function () {
				state.toolbarState.isSave = state.toolbarState.isSuccess = state.toolbarState.isResult = state.toolbarState.isLoading = state.toolbarState.isFail = false
			}, time)
		} else {
			state.toolbarState.isSave = state.toolbarState.isSuccess = state.toolbarState.isResult = state.toolbarState.isLoading = state.toolbarState.isFail = false
		}
	},
	syncBlockListMid(state, params) {
		state.blockListMid = [...params]
	},
	setHistoryBtnShow(state, num) {
		switch (num) {
		case -1:
			state.history.prevFalg = true
			state.history.nextFalg = false
			break
		case 1:
			state.history.prevFalg = false
			state.history.nextFalg = true
			break
		case 0:
			state.history.prevFalg = false
			state.history.nextFalg = false
			break
		case 2:
			state.history.prevFalg = true
			state.history.nextFalg = true
			break
		}
	},
	//页面定时发布数据
	SET_ALL_TIMING_DATA: (state, params) => {
		state.allTimingData = params
	},
}

export default mutations
